<template>
  <span>
    <template v-for="content in contents">
      <template v-if="isLink(content)">
        <!-- eslint-disable-next-line -->
        <RouterLink :class="linkClass" :to="links[content.tag].to">
          {{ links[content.tag].text }}
        </RouterLink>
      </template>
      <template v-else>
        {{ content }}
      </template>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    links: {
      type: Object,
      required: true,
    },

    updateOn: {
      type: String,
      default: null,
    },

    linkClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      contents: this.getContents(),
    };
  },

  watch: {
    updateOn(oldVal, newVal) {
      if (oldVal === newVal) {
        return;
      }

      this.contents = this.getContents();
    },
  },

  methods: {
    isLink(item) {
      // possible options are String and Object,
      // hence the following check is safe enough
      return typeof item === 'object';
    },

    getContents() {
      return parse(
        this.$slots.default.map(VNode => VNode.text.trim()).join(' '),
      );
    },
  },
};

function parse(str) {
  const treeList = [];
  let raw = str;

  while (hasDelimiter(raw)) {
    const delimiterStart = raw.indexOf('{');
    const delimiterEnd = raw.indexOf('}');
    const prevStr = raw.substring(0, delimiterStart);

    if (prevStr.length) {
      treeList.push(prevStr);
    }

    treeList.push({
      tag: raw.substring(delimiterStart + 1, delimiterEnd),
    });

    raw = raw.substring(delimiterEnd + 1); // ignoring the } delimiter
  }

  if (raw.length) {
    treeList.push(raw);
  }

  return treeList;
}

function hasDelimiter(str) {
  // return /\{[a-z]+\}+/i.test(str);
  const start = str.indexOf('{');
  const end = str.substring(start + 1).indexOf('}');

  return start > -1 && end > 0;
}
</script>
